<div class="view-bids-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <app-back-button
        label="Back to BOQ"
        [link]="['/home/boq']"
        class="back-btn">
      </app-back-button>
      <h1 class="page-title">Submitted Bids</h1>
    </div>
  </div>

  <div *ngIf="loading" class="loading-state">
    <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
    <p class="mt-4 text-gray-600">Loading bids...</p>
  </div>

  <div *ngIf="!loading && data" class="content-wrapper">
    <div class="info-bar">
      <p class="info-text">
        <strong>Project:</strong> {{ data.invitation.project_name }} |
        <strong>BOQ:</strong> {{ data.invitation.boq_code }} - {{ data.invitation.boq_name }}
      </p>
      <div class="info-bar-actions">
        <mat-button-toggle-group [value]="viewMode" (change)="setViewMode($event.value)" *ngIf="data.responses?.length">
          <mat-button-toggle value="individual">Individual Bids</mat-button-toggle>
          <mat-button-toggle value="comparison">Comparison & Deviation</mat-button-toggle>
        </mat-button-toggle-group>
        <button mat-raised-button color="accent" (click)="goToDeviationReport()" *ngIf="data.responses?.length">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">assessment</mat-icon>
          Deviation Report
        </button>
        <button mat-stroked-button (click)="goToVendorRanking()" *ngIf="data.responses?.length">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">leaderboard</mat-icon>
          Full ranking
        </button>
        <button mat-raised-button color="primary" (click)="openGeneratePoDialog()" *ngIf="hasRegisteredOrgBids()">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">description</mat-icon>
          Generate PO
        </button>
        <button mat-stroked-button (click)="goToPurchaseOrders()" *ngIf="generatedPos.length">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">receipt_long</mat-icon>
          View POs ({{ generatedPos.length }})
        </button>
      </div>
    </div>

    <!-- Vendor ranking summary -->
    <div *ngIf="ranking.length" class="ranking-card mb-4">
      <h3 class="ranking-title">
        <mat-icon style="font-size:20px;width:20px;height:20px">emoji_events</mat-icon>
        Vendor ranking (recommended award order)
      </h3>
      <div class="ranking-list">
        <div *ngFor="let r of ranking" class="ranking-row" [class.rank-first]="r.rank === 1">
          <span class="rank-badge">{{ r.rank }}</span>
          <span class="rank-name">{{ r.org_name }}</span>
          <span class="rank-score">{{ r.composite_score }} pts</span>
          <span class="rank-amount">{{ formatCurrency(r.bid_amount) }}</span>
        </div>
      </div>
    </div>
    <div *ngIf="rankingLoading" class="text-sm text-gray-500 mb-4">Computing vendor rankings…</div>

    <!-- Bidding Invitation Stats -->
    <div *ngIf="data.stats" class="stats-card">
      <h3 class="stats-title">
        <mat-icon style="font-size:20px;width:20px;height:20px">people</mat-icon>
        Bidding Invitation Stats
      </h3>
      <div class="stats-grid">
        <div class="stat-item">
          <p class="stat-value">{{ data.stats.total_invited }}</p>
          <p class="stat-label">Total Invited</p>
        </div>
        <div class="stat-item stat-completed">
          <p class="stat-value">{{ data.stats.completed }}</p>
          <p class="stat-label">Completed Bid</p>
        </div>
        <div class="stat-item stat-pending">
          <p class="stat-value">{{ data.stats.not_completed }}</p>
          <p class="stat-label">Pending</p>
        </div>
      </div>
      <div class="stats-table-wrap">
        <table class="stats-table">
          <thead>
            <tr>
              <th>Invited To</th>
              <th>Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let inv of data.stats.invited_details">
              <td>
                <span class="inv-name">{{ inv.name }}</span>
                <span *ngIf="inv.email && inv.type === 'org'" class="inv-email">({{ inv.email }})</span>
                <span *ngIf="inv.type === 'guest'" class="inv-email">({{ inv.email }})</span>
              </td>
              <td>
                <span *ngIf="inv.type === 'org'" class="badge badge-org">Organization</span>
                <span *ngIf="inv.type === 'guest'" class="badge badge-guest">Guest (Email)</span>
              </td>
              <td>
                <span *ngIf="inv.completed" class="badge badge-done">✓ Completed</span>
                <span *ngIf="!inv.completed" class="badge badge-wait">⏳ Pending</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Email & closing actions (only when bid is not closed) -->
    <div *ngIf="data.invitation?.status !== 'closed'" class="email-actions-card">
      <h3 class="email-actions-title">
        <mat-icon style="font-size:20px;width:20px;height:20px">email</mat-icon>
        Email & closing
      </h3>
      <div class="email-actions-buttons">
        <button mat-stroked-button color="primary" (click)="openInviteMoreDialog()" [disabled]="!canInviteMore()">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">person_add</mat-icon>
          Invite more
        </button>
        <button mat-stroked-button color="primary" (click)="sendBidReminder()" [disabled]="reminderSending || (data.stats?.not_completed || 0) === 0">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">notifications_active</mat-icon>
          {{ reminderSending ? 'Sending...' : 'Send reminder (pending only)' }}
        </button>
        <button mat-stroked-button color="primary" (click)="openExtendClosingDialog()" [disabled]="extendSending">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">schedule</mat-icon>
          {{ extendSending ? 'Extending...' : 'Extend closing date' }}
        </button>
        <button mat-stroked-button color="warn" (click)="openCloseBidDialog()" [disabled]="closeBidSending">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">block</mat-icon>
          {{ closeBidSending ? 'Closing...' : 'Close bid & notify all' }}
        </button>
      </div>
      <p class="email-actions-hint">
        Invite more adds organizations or emails to this same bidding link.
        <span *ngIf="(data.stats?.not_completed || 0) > 0"> Reminder will be sent to {{ data.stats.not_completed }} invitee(s) who have not submitted. Extend/Close will email all invitees.</span>
      </p>
    </div>

    <!-- Post-approval actions -->
    <div *ngIf="hasApprovedBid()" class="post-approval-card">
      <p class="post-approval-title">Bid approved. Next steps:</p>
      <div class="action-buttons">
        <button mat-raised-button color="accent" (click)="openAwardBiddersDialog()">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">gavel</mat-icon>
          Award to Bidders
        </button>
        <button mat-raised-button color="primary" (click)="openGeneratePoDialog()">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">description</mat-icon>
          Generate PO
        </button>
        <button mat-stroked-button color="primary" *ngIf="generatedPos.length === 1" (click)="openGeneratedPo(generatedPos[0])">
          Open generated PO
        </button>
        <button mat-stroked-button color="primary" *ngIf="generatedPos.length > 1" (click)="goToPurchaseOrders()">
          Open generated POs
        </button>
        <button mat-stroked-button color="primary" (click)="goToSurvey()">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">location_on</mat-icon>
          Survey
        </button>
        <button mat-stroked-button color="primary" (click)="goToWorkBreakdownStructure()">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">account_tree</mat-icon>
          Create Work Breakdown Structure
        </button>
        <button mat-stroked-button color="primary" (click)="goToResourceMobilization()">
          <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">groups</mat-icon>
          Resource Mobilization
        </button>
      </div>
    </div>

    <div *ngIf="data.responses?.length === 0" class="empty-state">
      <mat-icon class="empty-icon">inbox</mat-icon>
      <p>No bids submitted yet</p>
    </div>

    <!-- Comparison & Deviation View -->
    <div *ngIf="viewMode === 'comparison' && data.responses?.length" class="comparison-view">
      <!-- Specs & features style header with Show differences toggle -->
      <div class="comparison-section-header">
        <h2 class="comparison-section-title">Specs & features</h2>
        <div class="comparison-toggle-wrap">
          <span class="toggle-label">Show differences only</span>
          <mat-slide-toggle [(ngModel)]="showDifferencesOnly" color="primary"></mat-slide-toggle>
        </div>
      </div>
      <div class="comparison-summary-cards">
        <div class="summary-card">
          <span class="summary-label">Estimated Total</span>
          <span class="summary-value">{{ formatCurrency(getEstimatedTotal()) }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">Bids Received</span>
          <span class="summary-value">{{ data.responses?.length }}</span>
        </div>
        <div class="summary-card lowest" *ngIf="getLowestBid()">
          <span class="summary-label">Lowest Bid</span>
          <span class="summary-value">{{ formatCurrency(getLowestBid()?.amount) }}</span>
          <span class="summary-sublabel">{{ getLowestBid()?.bidder }}</span>
        </div>
        <div class="summary-card highest" *ngIf="getHighestBid()">
          <span class="summary-label">Highest Bid</span>
          <span class="summary-value">{{ formatCurrency(getHighestBid()?.amount) }}</span>
          <span class="summary-sublabel">{{ getHighestBid()?.bidder }}</span>
        </div>
      </div>

      <div class="comparison-table-card comparison-section">
        <button type="button" class="section-expand-btn" (click)="comparisonSectionExpanded = !comparisonSectionExpanded">
          <mat-icon class="section-expand-icon">{{ comparisonSectionExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          <mat-icon class="section-info-icon">info</mat-icon>
          <span>Bill of Quantities</span>
        </button>
        <div *ngIf="comparisonSectionExpanded" class="section-content">
        <p *ngIf="showDifferencesOnly && getFilteredComparisonRows().length === 0" class="no-differences-msg">
          All submitted bids have identical values for all items. Turn off "Show differences only" to see the full comparison.
        </p>
        <div class="overflow-x-auto" *ngIf="getFilteredComparisonRows().length">
          <table class="comparison-table">
            <thead>
              <tr>
                <th class="text-left sticky-col item-col">Item</th>
                <th class="text-right">Est. Qty</th>
                <th class="text-right">Est. Rate</th>
                <th class="text-right">Est. Amt</th>
                <ng-container *ngFor="let bid of data.responses">
                  <th colspan="4" class="bidder-group-header">{{ bid.org_name }}</th>
                </ng-container>
              </tr>
              <tr class="sub-header">
                <th class="text-left sticky-col item-col"></th>
                <th class="text-right"></th><th class="text-right"></th><th class="text-right"></th>
                <ng-container *ngFor="let bid of data.responses">
                  <th class="text-right">Qty</th>
                  <th class="text-right">Rate</th>
                  <th class="text-right">Amount</th>
                  <th class="text-right">Dev %</th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of getFilteredComparisonRows()" class="border-b hover:bg-gray-50">
                <td class="sticky-col item-col">
                  <span class="item-code">{{ row.item_code }}</span>
                  <span class="item-desc">{{ row.item_description }}</span>
                </td>
                <td class="text-right">{{ row.est_qty | number:'1.2-2' }}</td>
                <td class="text-right">{{ formatCurrency(row.est_rate) }}</td>
                <td class="text-right">{{ formatCurrency(row.est_amt) }}</td>
                <ng-container *ngFor="let bv of row.bidderValues; let bi = index">
                  <td class="text-right" [class.best-bid]="bv.isLowest">{{ bv.qty | number:'1.2-2' }}</td>
                  <td class="text-right" [class.best-bid]="bv.isLowest">{{ formatCurrency(bv.rate) }}</td>
                  <td class="text-right" [class.best-bid]="bv.isLowest">{{ formatCurrency(bv.amt) }}</td>
                  <td class="text-right" [ngClass]="getDeviationClass(bv.dev_pct)">
                    {{ bv.dev_pct === 0 ? '-' : (bv.dev_pct > 0 ? '+' : '') + (bv.dev_pct | number:'1.1-1') + '%' }}
                  </td>
                </ng-container>
              </tr>
              <tr class="totals-row font-bold">
                <td class="sticky-col item-col">Total</td>
                <td></td><td></td>
                <td class="text-right">{{ formatCurrency(getEstimatedTotal()) }}</td>
                <ng-container *ngFor="let bid of data.responses">
                  <td></td><td></td>
                  <td class="text-right">{{ formatCurrency(bid.bid_amount) }}</td>
                  <td class="text-right" [ngClass]="getDeviationClass(getTotalDeviationPct(bid))">
                    {{ getEstimatedTotal() > 0 ? (getTotalDeviationPct(bid) | number:'1.1-1') + '%' : '-' }}
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </div>

    <!-- Individual Bids View -->
    <div *ngIf="viewMode === 'individual' && data.responses?.length" class="bids-list">
      <div *ngFor="let bid of data.responses" class="bid-card" [ngClass]="{'bg-green-50': bid.status === 'shortlisted', 'bg-red-50': bid.status === 'rejected'}">
        <div class="bid-header">
          <div class="bidder-info">
            <h3 class="bidder-name">{{ bid.org_name }}</h3>
            <span *ngIf="bid.status === 'shortlisted'" class="status-badge approved">Approved</span>
            <span *ngIf="bid.status === 'rejected'" class="status-badge rejected">Declined</span>
          </div>
          <span class="bid-amount">{{ formatCurrency(bid.bid_amount) }}</span>
        </div>
        <div *ngIf="bid.bid_data?.items?.length" class="bid-items">
          <table class="items-table">
            <thead><tr class="border-b"><th class="text-left py-1">Item</th><th class="text-right py-1">Est. Qty</th><th class="text-right py-1">Est. Rate</th><th class="text-right py-1">Bid Qty</th><th class="text-right py-1">Bid Rate</th><th class="text-right py-1">Amount</th></tr></thead>
            <tbody>
              <tr *ngFor="let i of bid.bid_data.items" class="border-b">
                <td class="py-1">{{ i.item_code }}</td>
                <td class="py-1 text-right">{{ i.estimated_quantity ?? i.quantity }}</td>
                <td class="py-1 text-right">{{ formatCurrency(i.estimated_unit_rate ?? i.bid_rate) }}</td>
                <td class="py-1 text-right">{{ i.quantity }}</td>
                <td class="py-1 text-right">{{ formatCurrency(i.bid_rate) }}</td>
                <td class="py-1 text-right">{{ formatCurrency(i.line_total) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p *ngIf="bid.remarks" class="bid-remarks">{{ bid.remarks }}</p>
        <div class="bid-footer">
          <p class="submit-date">Submitted: {{ bid.created_at | date: 'medium' }}</p>
          <div *ngIf="bid.status === 'submitted'" class="bid-actions">
            <button mat-stroked-button color="primary" (click)="updateBidStatus(bid, 'shortlisted')" [disabled]="bid.updating">
              <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">check_circle</mat-icon>
              Approve
            </button>
            <button mat-stroked-button color="warn" (click)="updateBidStatus(bid, 'rejected')" [disabled]="bid.updating">
              <mat-icon class="mr-1" style="font-size:18px;width:18px;height:18px">cancel</mat-icon>
              Decline
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Queries from Bidders -->
    <div *ngIf="data.queries?.length" class="queries-section">
      <h3 class="section-title">Queries from Bidders</h3>
      <div *ngFor="let q of data.queries" class="query-card">
        <p class="query-org">{{ q.org_name }}</p>
        <p class="query-text">{{ q.query_text }}</p>
        <p class="query-date">{{ q.created_at | date: 'short' }}</p>
        <div *ngIf="q.reply_text" class="reply-box">
          <p class="reply-text">{{ q.reply_text }}</p>
          <p class="reply-date">Replied: {{ q.replied_at | date: 'short' }}</p>
        </div>
        <div *ngIf="!q.reply_text" class="reply-form">
          <textarea [(ngModel)]="replyTexts[q.id]" rows="2" placeholder="Type your reply..." class="reply-textarea"></textarea>
          <button mat-stroked-button color="primary" class="mt-2" (click)="replyToQuery(q)" [disabled]="!replyTexts[q.id]?.trim()">
            Reply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
